import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { SalesHistoryService } from "./../../../../services/pbm/sales-history.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { SalesHistoryCompany } from "src/app/ui/models/domains/pbm/sales-history/sales-history-company";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";
import { LoadingService } from "src/app/ui/services/loading.service";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { FilterOption } from "src/app/ui/models/domains/filters/filter-option";
import { FilterOptionType } from "src/app/ui/models/domains/filters/filter-option-type.enum";
import { Toast } from "../../../toast/toast";
import moment from "moment";
import { FilterFormValidator } from "../validators/filter-form-validator";
import { ProductService } from "src/app/ui/services/pbm/product.service";
import { UserService } from "src/app/ui/services/user.service";

@Component({
  selector: "sales-history-company",
  templateUrl: "./sales-history-company.component.html",
  styleUrls: ["./sales-history-company.component.scss"],
})
export class SalesHistoryCompanyComponent implements OnInit {
  private salesHistoryCompany: SalesHistoryCompany;
  private productTypes: ProductType[];
  public dataMask = MaskInput.getDateMask();
  private fiscalNumber: string;

  public filterForm: UntypedFormGroup = this.formBuilder.group({
    startDate: [moment().subtract(1, "M").format("DDMMYYYY")],
    endDate: [moment().format("DDMMYYYY")],
    productManufacturer: [],
    productType: [],
  });

  constructor(
    private featureViewService: FeatureViewService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private salesHistoryService: SalesHistoryService,
    private productService: ProductService,
    private loadingService: LoadingService,
    private toast: Toast,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.SalesHistoryCompany, PageViews.SalesHistoriesPageView);

    const paramns = this.activatedRoute.snapshot.queryParams;

    if (!!paramns.b) {
      const ref = this.loadingService.beginLoading();

      this.fiscalNumber = paramns.b;

      const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
      startDateFilter.setValue(moment().subtract(1, "M").format("DDMMYYYY"));

      const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
      endDateFilter.setValue(moment().format("DDMMYYYY"));

      const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
      productManufacturerFilter.setValue("");

      const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
      prouctTypeFilter.setValue("");

      const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
      fiscalNumberFilter.setValue(this.fiscalNumber);

      const filters: FilterOption[] = [];
      filters.push(startDateFilter);
      filters.push(endDateFilter);
      filters.push(productManufacturerFilter);
      filters.push(prouctTypeFilter);
      filters.push(fiscalNumberFilter);

      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      pagingRequest.setFilters(filters);

      try {
        this.productTypes = await this.productService.getProductTypes();
        this.salesHistoryCompany = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
      } catch (error) {
        this.toast.showWarningToast(error);
        this.storageSearchPreferences("");
        this.router.navigate([RoutePath.SalesHistoryCompanies]);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.router.navigate([RoutePath.SalesHistoryCompanies]);
    }
  }

  async onFilterChange(): Promise<any> {
    const ref = this.loadingService.beginLoading();

    const filterFormValidator = new FilterFormValidator();

    if (filterFormValidator.validate(this.filterForm).hasErrorMessages()) {
      this.toast.showWarningToast(filterFormValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const startDate = this.filterForm.get("startDate").value;
      const endDate = this.filterForm.get("endDate").value;
      const productManufacturer = this.filterForm.get("productManufacturer").value;
      const productType = this.filterForm.get("productType") ? this.filterForm.get("productType").value : "";

      const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
      startDateFilter.setValue(moment(startDate, "DD/MM/YYYY").format("DDMMYYYY"));

      const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
      endDateFilter.setValue(moment(endDate, "DD/MM/YYYY").format("DDMMYYYY"));

      const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
      productManufacturerFilter.setValue(productManufacturer);

      const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
      prouctTypeFilter.setValue(productType);

      const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
      fiscalNumberFilter.setValue(this.fiscalNumber);

      const filters: FilterOption[] = [];
      filters.push(startDateFilter);
      filters.push(endDateFilter);
      filters.push(productManufacturerFilter);
      filters.push(prouctTypeFilter);
      filters.push(fiscalNumberFilter);

      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      pagingRequest.setFilters(filters);

      try {
        this.salesHistoryCompany = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
      } catch (error) {
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  async searchMore(): Promise<any> {
    const ref = this.loadingService.beginLoading();

    const startDate = this.filterForm.get("startDate").value;
    const endDate = this.filterForm.get("endDate").value;
    const productManufacturer = this.filterForm.get("productManufacturer").value;
    const productType = this.filterForm.get("productType") ? this.filterForm.get("productType").value : "";

    const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
    startDateFilter.setValue(moment(startDate, "DD/MM/YYYY").format("DDMMYYYY"));

    const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
    endDateFilter.setValue(moment(endDate, "DD/MM/YYYY").format("DDMMYYYY"));

    const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
    productManufacturerFilter.setValue(productManufacturer);

    const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
    prouctTypeFilter.setValue(productType);

    const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
    fiscalNumberFilter.setValue(this.fiscalNumber);

    const filters: FilterOption[] = [];
    filters.push(startDateFilter);
    filters.push(endDateFilter);
    filters.push(productManufacturerFilter);
    filters.push(prouctTypeFilter);
    filters.push(fiscalNumberFilter);

    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(this.salesHistoryCompany.getPagingInfo().getEnd());
    pagingRequest.setEnd(10);
    pagingRequest.setFilters(filters);

    try {
      const result = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
      this.salesHistoryCompany.setPagingInfo(result.getPagingInfo());
      this.salesHistoryCompany.addItems(result.getcompanySalesHistoryItemList());
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  backToSalesHistorySummary(): void {
    this.userService.setUserPreferences("");
    this.router.navigate([RoutePath.SalesHistoryCompanies]);
  }

  hasSalesHistoryCompany(): boolean {
    return !!this.salesHistoryCompany;
  }

  hasSalesHistoryCompanyItem(): boolean {
    return !!this.salesHistoryCompany && this.salesHistoryCompany.getcompanySalesHistoryItemList().length > 0;
  }

  getSalesHistoryCompany(): SalesHistoryCompany {
    return this.salesHistoryCompany;
  }

  getProductTypes(): ProductType[] {
    return this.productTypes;
  }

  storageSearchPreferences(fiscalNumber: string = ""): void {
    this.userService.setUserPreferences(fiscalNumber.replace(/[./-]/g, ""));
  }
}
